import React from "react";
import "./Security.css";
import Navbar from "../Common/Navbar";
import SecurityHero from "./SecurityPage/SecurityHero";
import SecurityFeatures from "./SecurityPage/SecurityFeatures";
import SslProtectionSection from "./SecurityPage/SslProtectionSection";
import HowSecurityWorks from "./SecurityPage/HowSecurityWorks";
import SecurityCTA from "./SecurityPage/SecurityCTA";

function Security() {
  return (
    <>
      <Navbar />

      <main className="security-page-wrapper">
        <div className="security-bg-glow security-bg-glow-one"></div>
        <div className="security-bg-glow security-bg-glow-two"></div>

        <div className="security-main-container">
          <SecurityHero />
          <SecurityFeatures />
          <SslProtectionSection />
          <HowSecurityWorks />
          <SecurityCTA />
        </div>
      </main>
    </>
  );
}

export default Security;